/**
  *  字典类数据
  *  @author  liuguisheng
  *  @date  2019-9-21
  *  
*/

/****************************************  
  
                 表单设置相关  

 ****************************************/

// 组件尺寸
export const componentSizeList = [
    {
        label: 'medium',
        value: '中等'
    },
    {
        label: 'small',
        value: '小'
    },
    {
        label: 'mini',
        value: '极小'
    }
]


/****************************************  
  
                 组件设置相关  

 ****************************************/

// 节流时间
export const buttonThrottleList = [
    {
        value: 0,
        label: 0
    },
    {
        value: 500,
        label: 500
    },
    {
        value: 1000,
        label: 1000
    },
    {
        value: 2000,
        label: 2000
    },
    {
        value: 3000,
        label: 3000
    }
]

// 按钮尺寸
export const buttonSizeList = [
    {
        value: '正常',
        label: 'undefined'
    },
    {
        value: '小型',
        label: 'small'
    }
]

// 按钮类型
export const buttonTypeList = [
    {
        label: '正常',
        value: 'undefined'
    },
    {
        label: '主要',
        value: 'primary'
    },
    {
        label: '警告',
        value: 'warning'
    },
    {
        label: '危险',
        value: 'danger'
    },
    {
        label: '文字',
        value: 'text'
    }
]
// 标签位置
export const labelPositionList = [
    {
        label: 'left',
        value: '左边'
    },
    {
        label: 'right',
        value: '右边'
    }
]

// 标签文本位置
export const labelTextPositionList = [
    {
        label: 'left',
        value: '左对齐'
    },
    {
        label: 'right',
        value: '右对齐'
    }
]


/****************************************  
  
                事件设置相关  

 ****************************************/

// 事件配置列表
export const eventConfigList = [
    // { 1:显示, 6:隐藏 }
    {
        label: "显示",
        value: 1
    },
    {
        label: "隐藏",
        value: 6
    },
    // { 4:解禁, 5:禁用 }
    {
        label: "解禁",
        value: 4             
    },
    {
        label: "禁用",
        value: 5
    },
    // { 2:复制, 3:删除 }
    {
        label: "复制/删除",
        value: 2
    },
]

// 组合方式
export const makeUpTypeList = [
    {
        label: "条件同时成立",
        value: 10
    },
    {
        label: "满足任意条件成立",
        value: 20
    }
]


/****************************************  
  
                样式设置相关  

 ****************************************/

//  加粗
export const strongConfigList = function(type) {
  let configMap = new Map([
    ['text', [
      { value: '否', label: 'none' },
      { value: '是', label: 'all' }
    ]],
    ['default', [
      { value: '无', label: 'none' },
      { value: '标签', label: 'label' },
      { value: '值', label: 'value'},
      { value: '全部', label: 'all'}
    ]]
  ]);

  return configMap.has(type) ? configMap.get(type) : configMap.get('default');
}


// 斜体
export const italicConfigList = function(type) {
  let configMap = new Map([
    ['text', [
      { value: '否', label: 'none' },
      { value: '是', label: 'all' }
    ]],
    ['default', [
      { value: '无', label: 'none' },
      { value: '标签', label: 'label' },
      { value: '值', label: 'value' },
      { value: '全部', label: 'all' }
    ]]
  ])

  return configMap.has(type) ? configMap.get(type) : configMap.get('default');
}

// 行高
export const lineHeightConfigList = [
    {
        value: '1.5倍',
        label: '1.5'
    },
    {
        value: '2倍',
        label: '2.0'
    },
    {
        value: '2.5倍',
        label: '2.5'
    }
]

// 对齐方式
export const alignConfigList = [
    {
        value: '无',
        label: 'none'
    },
    {
        value: '左',
        label: 'left'
    },
    {
        value: '中',
        label: 'center'
    },
    {
        value: '右',
        label: 'right'
    }
]

// 换行
export const wrapConfigList = [
    {
        value: '否',
        label: false
    },
    {
        value: '是',
        label: true
    }
]

// 文字组件下划线配置
export const textUnderLineConfig = [
    {
        value: '否',
        label: 'none'
    },
    {
        value: '是',
        label: 'underline'
    }
]

// 展示配置
export const showConfigList = [
    {
        value: '表单',
        label: 'form'
    },
    {
        value: '模板',
        label: 'render'
    },
    {
        value: '全部',
        label: 'all'
    }
    
]

// 渲染颜色设置
export const renderColorConfigList = [
    {
        value: '标签',
        label: 'label'
    },
    {
        value: '值',
        label: 'value'
    },
    {
        value: '全部',
        label: 'all'
    }
    
]

// 表单项校验规则配置项
export const formValidatorRuleList = [
    {
        label: '身份证',
        value: '身份证'
    },
    {
        label: '手机号',
        value: '手机号'
    },
    {
        label: '数字',
        value: '数字'
    },
    {
        label: '汉字',
        value: '汉字'
    }
] 
/** @name 通过表单项验证配置获取校验方法
 *  @param {Object} validatorConfig 校验配置
 *  - {Boolean} isRequire 是否必填
 *  - {String} ruleSelected 验证类型选择
 *  - {Number} minValue 最小值
 *  - {Number} maxValue 最大值
 *  - {Boolean} isMoney 是否转金额/大写
 *  @return {Function}
 */
export const formValidatorRuleFunction = function(validatorConfig) {
    let { isRequire, ruleSelected, minValue, maxValue, isMoney } = validatorConfig;
    switch(ruleSelected) {
      case '身份证': return (rule, value, callback) => {
        var city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' };
        var birthday = value.substr(6, 4) + '/' + Number(value.substr(10, 2)) + '/' + Number(value.substr(12, 2));
        var d = new Date(birthday);
        var newBirthday = d.getFullYear() + '/' + Number(d.getMonth() + 1) + '/' + Number(d.getDate());
        var currentTime = new Date().getTime();
        var time = d.getTime();
        var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        var sum = 0;
        var i;
        var residue;
        for (i = 0; i < 17; i++) {
            sum += value.substr(i, 1) * arrInt[i];
        }
        residue = arrCh[sum % 11];
        if (value === '') {
            return callback(new Error('请输入身份证号'));
        } else if (!/^\d{17}(\d|x)$/i.test(value) || city[value.substr(0, 2)] === undefined || time >= currentTime || birthday !== newBirthday || residue !== value.substr(17, 1)) {
            return callback(new Error('请输入合法身份证号'));
        } else {
            callback();
        }
      }
      case '手机号': return (rule, value, callback) => {
        let validatorResult = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(value);
        validatorResult ? callback() : callback(new Error("格式错误"));
      }
      case '数字': return (rule, value, callback) => {
        let validatorResult = /^\d+(\.\d+)?$/.test(value);
        if (validatorResult === false) return callback(new Error("格式错误"));

        let floatValue = Number.parseFloat(value);
        if ((Number.parseFloat(minValue)) && (floatValue < minValue)) return callback(new Error("格式错误"));
        if ((Number.parseFloat(maxValue)) && (floatValue > maxValue)) return callback(new Error("格式错误"));

        callback();           
      }
      case '汉字': return (rule, value, callback) => {
        let validatorResult = /^[\u4e00-\u9fa5]+$/.test(value);
        if (validatorResult === false) return callback(new Error("格式错误"));

        if ((Number.parseInt(minValue)) && (value.length < minValue)) return callback(new Error("格式错误"));
        if ((Number.parseInt(maxValue)) && (value.length > maxValue)) return callback(new Error("格式错误"));

        callback();
      }
      default: {
        return (Number.parseInt(minValue) || Number.parseInt(maxValue))
                ? (rule, value, callback) => {
                    if ((Number.parseInt(minValue)) && (value.length < minValue)) return callback(new Error("格式错误"));
                    if ((Number.parseInt(maxValue)) && (value.length > maxValue)) return callback(new Error("格式错误"));
                    callback();
                  }
                : null;
      }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/config_dictionary.js